/**
 * Brand assets for the Murabbi Youth Initiative (MYI) — the flagship program
 * living on /consulting/youth-mentorship-guidance.
 *
 * Kept separate from the site's primary brand so MYI can evolve its own
 * identity without touching global styles.
 */

export const MYI_LOGO_FULL =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_hero-design-6/artifacts/f5lgkqy7_image.png";

export const MYI_ICON =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_hero-design-6/artifacts/lba62ksa_myi%20logo.png";
